import React from 'react';
import App from 'app';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { defaultState, StateProvider } from './state';
import reducers from './state/reducers';
import { SENTRY_DSN, SENTRY_ENV } from './utils/config';

Sentry.init({
  dsn: SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
  ],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
  environment: SENTRY_ENV,
});

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container element not found');
}
const root = createRoot(container);
root.render(
  <StateProvider initialState={defaultState} reducer={reducers}>
    <App />
  </StateProvider>
);
